import { render } from "./DetailsMedicament.vue?vue&type=template&id=8cb1a976&scoped=true"
import script from "./DetailsMedicament.vue?vue&type=script&lang=js"
export * from "./DetailsMedicament.vue?vue&type=script&lang=js"

import "./DetailsMedicament.vue?vue&type=style&index=0&id=8cb1a976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb1a976"]])

export default __exports__